import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { renderShellLink } from "./links.js";
import { useAppShell } from "./ShellContext.js";
const BottomNav = React.forwardRef(function BottomNav2({ items, label = "Main", renderLink, onOpenDrawer, className, ...rest }, ref) {
  const shell = useAppShell();
  if (items.length === 0) return null;
  const linkRenderer = renderLink ?? shell?.renderLink;
  const shellDrawer = shell?.hasDrawer === true;
  return /* @__PURE__ */ jsx("nav", { ref, className: cx("ev-bottom-nav", className), "aria-label": label, ...rest, children: items.map((item) => {
    const content = /* @__PURE__ */ jsxs(Fragment, { children: [
      item.icon != null && /* @__PURE__ */ jsx("span", { className: "ev-bottom-nav__icon", "aria-hidden": "true", children: item.icon }),
      /* @__PURE__ */ jsx("span", { className: "ev-bottom-nav__label", children: item.label })
    ] });
    if (item.opensDrawer) {
      if (!shellDrawer && !onOpenDrawer) return null;
      return /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          "aria-haspopup": "dialog",
          "aria-expanded": shellDrawer ? shell?.drawerOpen : void 0,
          onClick: () => {
            if (shellDrawer) shell?.setDrawerOpen(true);
            onOpenDrawer?.();
          },
          children: content
        },
        item.id
      );
    }
    if (item.href != null) {
      return /* @__PURE__ */ jsx(React.Fragment, { children: renderShellLink(
        linkRenderer,
        { href: item.href, "aria-current": item.current ? "page" : void 0, children: content },
        { id: item.id, href: item.href }
      ) }, item.id);
    }
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        "aria-current": item.current ? "page" : void 0,
        onClick: item.onSelect,
        children: content
      },
      item.id
    );
  }) });
});
export {
  BottomNav
};
//# sourceMappingURL=BottomNav.js.map
